import {ArrowBack} from '@mui/icons-material';
import {IconButton} from '@mui/material';
import * as React from 'react';

export const FlatAppBarBackButton = (props: {onClick: () => void}) => (
  <IconButton sx={{color: 'white', zIndex: 1}} onClick={props.onClick}>
    <ArrowBack />
  </IconButton>
);
